import type React from "react";
import { CategoryTemplateManagement } from "@/components/catalog/category-templates/category-template-management";

const CategoryTemplatesPage: React.FC = () => {
  return (
    <main className="flex-1 space-y-6 p-2">
      <div className="space-y-2">
        <h2 className="text-3xl font-bold tracking-tight bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent">
          Categories &amp; Attributes
        </h2>
        <p className="text-muted-foreground">
          Manage reusable category and attribute templates for catalogue setup.
        </p>
      </div>

      <CategoryTemplateManagement />
    </main>
  );
};

export default CategoryTemplatesPage;
